import * as OM from '@/model';
import * as VM from '@/viewmodel';
import * as Enum from '@/enum';
import { CommonServices } from '@/services/CommonServices';
import { StorageServices } from '@/services/StorageServices';
import router from '@/router';
import store from '@/store';
import { AgentSubscriptionClient, BaseUserClient, ChatRoomClient, ClubSubscriptionClient, InAppNotificationClient, LoginClient, ProjectConfigClient } from './Services';
import { WsServices } from './WsServices';
import { PushServices } from './PushServices';

class _LoginServices {
    
    loginCallback(loginData: OM.LoginData){
        store.state.loginData = loginData;
        StorageServices.setLoginData(loginData);
        CommonServices.setAuthToken(loginData.token);
            
        WsServices.ConnectSocket();
        WsServices.SetNotificationListener((value) => {
            if(value.notificationData.type == 'NewChatMessage'){
                let data = value.notificationData as OM.NewChatMessage;
                if(data.villageIdentifier){
                    store.state.hasNewChatMessages.villages[data.villageIdentifier] = true;
                } else {
                    store.state.hasNewChatMessages.network = true;
                }
            } else {
                store.state.inAppNotificationsCount++;
            }
        })
        WsServices.SetEnableAffiliateAreaListener(() => {
            Promise.all([
                BaseUserClient.getById(loginData.userIdentifier),
                LoginClient.refreshLogin(),
                ClubSubscriptionClient.getActiveSubscription(store.state.loginData.userIdentifier),
                AgentSubscriptionClient.getActiveSubscription(store.state.loginData.userIdentifier)
            ])
            .then(xs => {
                store.state.user = xs[0];
                store.state.loginData = xs[1];
                store.state.clubSubscription = xs[2];
                store.state.agentSubscription = xs[3];
                if(router.currentRoute.value.name == 'buyClubSubscription' || router.currentRoute.value.name == 'membershipLanding'){
                    router.replace("/network/home");
                }
            })
        })

        return new Promise<any>((resolve, reject) => {
            Promise.all([
                BaseUserClient.getById(loginData.userIdentifier),
                InAppNotificationClient.getUnreadCountByUser(store.state.loginData.userIdentifier),
                ClubSubscriptionClient.getActiveSubscription(store.state.loginData.userIdentifier),
                AgentSubscriptionClient.getActiveSubscription(store.state.loginData.userIdentifier),
                ChatRoomClient.checkNewMessagesForUser(store.state.loginData.userIdentifier),
                ProjectConfigClient.getAuraCoinValue(),
            ])
            .then(xs => {
                store.state.user = xs[0];

                if(window.cordova){
                    document.addEventListener("deviceready", () => {
                        PushServices.register(
                            (token) => {
                                BaseUserClient.saveFcmId({
                                    userIdentifier: store.state.user.identifier,
                                    fcmId: token
                                })
                            }
                        )
                        .then(x => {
                        });
                    }, false)
                }


                store.state.inAppNotificationsCount = xs[1];
                store.state.clubSubscription = xs[2];
                store.state.agentSubscription = xs[3];
                store.state.hasNewChatMessages = xs[4];
                store.state.auracoinMultiplier = xs[5];

                if(store.state.villageConfig){
                    store.state.getVillageByCoords(true)
                }

                if(!store.state.user.personalData.name || !store.state.user.personalData.surname){
                // if(!store.state.user.fiscalData.birthDate || !store.state.user.personalData.country || !store.state.user.contactData.telephone.number){
                    router.push('/completeProfile').then(x => resolve(null));
                } else {
                    if(router.currentRoute.value.query.redirect){
                        router.push(<string>router.currentRoute.value.query.redirect).then(x => resolve(null));
                    } else {
                        resolve(store.state.user);
                    }
                }
            })
        })
    }

    logout(){
        let prom = new Promise<void>((resolve, reject) => {
            CommonServices.destroyToken();
            store.state.user = null;
            store.state.loginData = null;
            store.state.villageConfig = null;
            StorageServices.clearData();

            if(window.cordova){
                PushServices.unregister();
            }

            resolve();
        })
        return prom;
    }

    googleInitialized: boolean = false;
    initGoogle(buttonContainer, onSuccess: (loginData: OM.LoginData) => void, onError: (err) => void){
        if(!this.googleInitialized){
            google.accounts.id.initialize({
                client_id: '456907092177-i7r38dmglbcg57pt1hv7vt3uqr4ec28j.apps.googleusercontent.com', // Il tuo webClientId
                callback: (response) => {
                    const idToken = response.credential;
                    LoginClient.loginFromGoogle({
                        idToken: idToken,
                        preferredCulture: store.state.selectedLanguage,
                        villageIdentifier: store.state.villageConfig ? store.state.villageConfig.identifier : null
                    })
                    .then(x => {
                        onSuccess(x);
                    })
                    .catch(err => {
                        onError(err);
                    });
                },
                cancel_on_tap_outside: true
            });
            this.googleInitialized = true;
        }
        google.accounts.id.renderButton(buttonContainer, {
            type: 'standard',
            theme: 'filled_black',
            size: 'large',
            text: 'signin_with',
            shape: 'pill',
            logo_alignment: 'left',
            locale: 'it'
        });
    }

    googleLogin(){
        let promCb: (resolve, reject) => void;
        if(window.cordova){
            promCb = (resolve, reject) => {
                FirebasePlugin.authenticateUserWithGoogle(
                    "648281692101-hvjcnb0tqsj13r3v6g4qfh1v1ql1glkd.apps.googleusercontent.com",
                    function (credential) {
                        FirebasePlugin.signInWithCredential(
                            credential,
                            function () {
                                LoginClient.loginFromGoogle({
                                    idToken: credential.idToken,
                                    preferredCulture: store.state.selectedLanguage,
                                    villageIdentifier: store.state.villageConfig ? store.state.villageConfig.identifier : null
                                })
                                .then(x => {
                                    resolve(x);
                                })
                            },
                            function (error) {
                                console.log("error in signInWithCredential", error);
                                reject(error);
                            }
                        );
                    },
                    function (error) {
                        console.log("error in authenticateUserWithGoogle", error);
                        reject(error);
                    }
                );
            } 
        } else {
            // promCb = (resolve, reject) => {
            //     let googleProm = new Promise<void>((googleResolve, reject) => {
            //         if(this.googleInitialized){
            //             googleResolve();
            //         } else {
            //             google.accounts.id.initialize({
            //                 client_id: '456907092177-i7r38dmglbcg57pt1hv7vt3uqr4ec28j.apps.googleusercontent.com', // Il tuo webClientId
            //                 callback: (response) => {
            //                     const idToken = response.credential;
                                
            //                     LoginClient.loginFromGoogle({
            //                         idToken: idToken,
            //                         preferredCulture: store.state.selectedLanguage,
            //                         villageIdentifier: store.state.villageConfig ? store.state.villageConfig.identifier : null
            //                     })
            //                     .then(x => {
            //                         resolve(x);
            //                     })
            //                     .catch(err => {
            //                         reject(err);
            //                     });
            //                 },
            //                 cancel_on_tap_outside: true
            //             });
            //             this.googleInitialized = true;
            //             googleResolve();
            //         }
            //     })
            //     googleProm.then(x => {
            //         google.accounts.id.prompt((notification) => {
            //             if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
            //                 reject();
            //             }
            //         });
            //     })
            // }
            
        }
        return new Promise<OM.LoginData>(promCb);
    }


    appleLogin(){
        let promCb: (resolve, reject) => void;
        if(window.cordova){
            promCb = (resolve, reject) => {
                FirebasePlugin.authenticateUserWithApple(
                    function (credential) {
                        LoginClient.loginFromApple({
                            idToken: credential.idToken,
                            preferredCulture: store.state.selectedLanguage,
                            villageIdentifier: null,
                            name: credential.givenName,
                            surname: credential.familyName
                        })
                        .then(x => {
                            resolve(x);
                        })
                        .catch(err => {
                            reject(err);
                        });
                    },
                    function (error) {
                        reject(error);
                    },
                    "it_IT"
                );
            } 
        }
        return new Promise<OM.LoginData>(promCb);
    }

}

export let LoginServices = new _LoginServices();